module.exports = __webpack_public_path__ + "static/img/tabletupianc1.f6d4cde.png";